<main class="surveillance-page" dir="rtl">
  <header class="surveillance-header">
    <a class="back" [routerLink]="['/carInfo', unitId]" title="بازگشت به خودرو" aria-label="بازگشت به خودرو">
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </a>
    <h1 class="title">نظارت تصویری</h1>
  </header>

  <section class="vehicle-summary" *ngIf="vehicle" aria-label="مشخصات خودرو">
    <span><i class="fa fa-car" aria-hidden="true"></i> شماره خودرو <strong>{{ (vehicle.iCode ?? '—') | faNum }}</strong></span>
    <span><i class="fa fa-user" aria-hidden="true"></i> راننده <strong>{{ (vehicle.strFullName || '—') | faNum }}</strong></span>
    <span><i class="fa fa-credit-card" aria-hidden="true"></i> پلاک <strong>{{ (vehicle.strVehicleNo || '—') | faNum }}</strong></span>
  </section>

  <div class="surveillance-feedback" *ngIf="loading" role="status">
    <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i> در حال دریافت اطلاعات دوربین‌ها…
  </div>
  <div class="surveillance-feedback is-error" *ngIf="error && !loading" role="alert">
    <span><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ error }}</span>
    <button type="button" (click)="loadVehicle()">تلاش دوباره</button>
  </div>

  <section class="camera-grid" aria-label="دوربین‌های خودرو">
    <article class="camera-card" *ngFor="let camera of cameras" [attr.aria-labelledby]="'camera-title-' + camera.channel">
      <header class="camera-header">
        <div>
          <h2 [id]="'camera-title-' + camera.channel">{{ camera.title }}</h2>
          <span class="camera-status" [class.is-live]="camera.enabled && camera.url" aria-live="polite">
            <i class="fa" [ngClass]="camera.error ? 'fa-exclamation-circle' : 'fa-circle'" aria-hidden="true"></i>
            {{ camera.loading ? 'در حال اتصال' : camera.error ? 'اتصال ناموفق' : camera.enabled && camera.url ? 'پخش زنده' : 'خاموش' }}
          </span>
        </div>
        <label class="camera-toggle">
          <input type="checkbox" role="switch" [(ngModel)]="camera.enabled" (ngModelChange)="toggleCamera(camera)"
            [disabled]="loading || !!error || camera.busy" [attr.aria-label]="'فعال کردن ' + camera.title">
          <span aria-hidden="true"></span>
        </label>
      </header>
      <div class="camera-preview" [attr.aria-busy]="camera.loading">
        <video-player *ngIf="camera.enabled && camera.url" [obj_Cam]="camera.player" [src]="camera.url"></video-player>
        <div class="camera-placeholder" *ngIf="!camera.url || !camera.enabled" role="status">
          <i class="fa" [ngClass]="camera.loading ? 'fa-circle-o-notch fa-spin' : camera.error ? 'fa-exclamation-triangle' : 'fa-video-camera'" aria-hidden="true"></i>
          <strong>{{ camera.loading ? 'در انتظار تصویر دوربین' : camera.error ? 'دریافت تصویر ناموفق بود' : 'دوربین خاموش است' }}</strong>
          <p>{{ camera.error || (camera.loading ? 'برقراری ارتباط ممکن است تا یک دقیقه طول بکشد.' : 'برای مشاهده تصویر، دوربین را روشن کنید.') }}</p>
        </div>
      </div>
    </article>
  </section>
</main>
